import { useRef } from "react";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useSYS1010_R01Store } from "src/containers/mes/SYS/SYS1010_R01/Store_SYS1010_R01";
import useUiuxStore from "src/store/useUiuxStore";

// Props 타입 정의: 코드 입력값, 변경 핸들러, 엔터키 핸들러
interface Props {
  onEnterKeyDown: () => void;
}

// 공통코드 검색 영역 컴포넌트
export const SearchSection_SYS1010_R01 = (props: Props) => {
  const { onEnterKeyDown } = props;

  const { setCommonCodeModalVisible } = useUiuxStore();
  const { SYS1010_R01Filter, setSYS1010_R01Filter } = useSYS1010_R01Store();

  const inputRef = useRef<HTMLInputElement>(null);

  return (
	<>
    	<div className="w-full flex items-start px-[12px] gap-[6px]">
			<div className="w-full flex flex-col transition-all duration-500">
				<div className="w-full h-[40px] flex items-center justify-between gap-[8px] border-gray-300 px-[12px] py-[4px] mb-[4px] border overflow-y-auto">
					<SearchInputForm
						label="공통코드명"
						value={SYS1010_R01Filter.codeInput}
						onChange={(e) => {
							setSYS1010_R01Filter({...SYS1010_R01Filter, codeInput: e.target.value.toUpperCase()});
						}}
						onKeyDown={(e) => {
							if (e.key === 'Enter') onEnterKeyDown();
						}}
						initValue={() => setSYS1010_R01Filter({...SYS1010_R01Filter, codeInput: ''})}
					/>
					<div className="w-[85px] min-w-[85px] h-full flex items-center justify-end flex-shrink-0">
						<button
							className="w-full h-[80%] text-white rounded-[4px] bg-blue-dark px-[16px] font-semibold"
							onClick={() => setCommonCodeModalVisible(true)}
						>
							코드등록
						</button>
					</div>
				</div>
			</div>
		</div>
	</>
  );
};

export default SearchSection_SYS1010_R01;